import { User } from '../hooks/api/useUser';

/** Matches scheduling slot size and DEFAULT_LOC_CALL_UNITS_LENGTH on the backend. */
export const MIN_SCHEDULING_MINUTES = 30;

export type SchedulingBlockReason = 'loading' | 'payment_failed' | 'no_credit';

export type CanMemberScheduleCallResult = { canSchedule: true } | { canSchedule: false; reason: SchedulingBlockReason };

export function canMemberScheduleCall(user: User | null | undefined): CanMemberScheduleCallResult {
  if (!user?.caller_role) {
    return { canSchedule: false, reason: 'loading' };
  }

  if (user.onUnlimitedPlan) {
    return { canSchedule: true };
  }

  const minutes = user.caller_role.payment_data.available_minutes;
  const hasEnoughMinutes = minutes >= MIN_SCHEDULING_MINUTES;
  const hasPaymentMethod = !!user.caller_role.stripe_payment_method_id;

  if (!hasEnoughMinutes && !hasPaymentMethod) {
    return { canSchedule: false, reason: 'no_credit' };
  }

  // Mirror backend: payment failure only blocks when prepaid balance is 0 and
  // the member would rely on pay-per-minute billing.
  if (minutes === 0 && hasPaymentMethod && user.caller_role.stripe_payment_failed) {
    return { canSchedule: false, reason: 'payment_failed' };
  }

  return { canSchedule: true };
}
